<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/msg/conf/page" getKey="rows"
			:columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('业务名称')">
						<el-input v-model="yt.conditions.msgName"></el-input>
					</el-form-item>
          <el-form-item :label="$t('业务编码')">
            <el-input v-model="yt.conditions.msgCode"></el-input>
          </el-form-item>
					<el-form-item :label="$t('shifouqiyong')">
            <el-select v-model="yt.conditions.enabled">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
					</el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.conditions.remark"></el-input>
          </el-form-item>

					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain="plain">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({orderBy:'createTime desc'})">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<!-- 左侧按钮插槽 -->
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<!-- 右侧按钮插槽 -->
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
			</template>
			<!-- 操作插槽 -->
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
						</el-button>
					</el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('tuisongcanshuyingshe', scope.row, '70%')">{{$t('推送参数映射')}}
            </el-button>
          </el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/msg/conf/delete')">
							{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>

		</yi_curd_table>

		<!-- 新增/编辑弹框 -->
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 新增表单 -->
			<template v-if="yt.editObj.action == 'xinzeng'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
					<el-form-item :label="$t('业务名称')" required>
						<el-input v-model="yt.editObj.msgName"></el-input>
					</el-form-item>
          <el-form-item :label="$t('业务编码')" required>
            <el-input v-model="yt.editObj.msgCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('消息类型')" required>
            <el-select filterable :clearable="true" v-model="yt.editObj.type">
              <el-option :label="$t('平台消息')" :value="1"></el-option>
              <el-option :label="$t('系统/公告消息')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enabled">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>

          </el-form-item>

				</el-form>
				<template slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/msg/conf/create')" type="primary">
						{{$t('baocun')}}
					</el-button>
				</template>
			</template>
			<!-- 更新表单 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('业务名称')" required>
            <el-input disabled v-model="yt.editObj.msgName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('业务编码')" required>
            <el-input disabled v-model="yt.editObj.msgCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('消息类型')" required>
            <el-select filterable :clearable="true" v-model="yt.editObj.type">
              <el-option :label="$t('平台消息')" :value="1"></el-option>
              <el-option :label="$t('系统/公告消息')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <el-select v-model="yt.editObj.enabled">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>

          </el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" @click="yt.req('POST','/web/msg/conf/update')" type="primary">
						{{$t('baocun')}}
					</el-button>

				</span>
			</template>

      <!-- 推送参数映射 -->
      <template v-if="yt.editObj.action == 'tuisongcanshuyingshe'">
        <div class="dialog-scroller">
          <message_mapping :msgConfId="yt.editObj.id"></message_mapping>
        </div>
      </template>

		</el-dialog>
	</div>
</template>
<script type="text/javascript">
  import message_mapping from '@@/pages/admin/global/message/mapping'
	export default {
		name: 'admin_global_message_list',
		components: {
      message_mapping
		},
		data() {
			return {
				show: false,
				fildIds: '',
				timer: null,
				list: [],

				columns: [{
					label: '业务名称',
					prop: 'msgName',
				}, {
					label: '业务编码',
					prop: 'msgCode',
				}, {
					label: '消息类型',
          type: 'tag',
          prop: 'type',
          tags: {
            1: {
              color: '#3c86e6',
              text: this.$t('平台消息')
            },
            2: {
              color: '#67C23A',
              text: this.$t('系统/公告消息')
            }
          },
				}, {
					label: '是否启用',
					prop: 'enabled',
          type: 'bool',
          iln18: ['shi', 'fou']
				}, {
					label: 'beizhu',
					prop: 'remark'
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 230,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					orderBy: 'createTime desc',
				}
				this.yt.get(1);
				this.utils.event_hub.$on('ADMIN_INFO_REFRESH', () => {
					this.yt.get(1);
				})
			}, 300)
		},
		destroyed() {
			clearTimeout(this.timer)
		},
		methods: {

		}
	};
</script>
